<div class="headings">
  <h4 class="content-heading">
    {{ 'pages.user-cards.create.steps.information.heading' | translate }}
  </h4>
</div>

<article *ngIf="instructionsStepsInfo" class="article-mb quill-content-wrapper ql-editor" 
  [innerHTML]="instructionsStepsInfo | safeHtml">
</article>

<form [formGroup]="form">
  <div class="user-bcitiCard">

    <div class="user-infos">
      <div class="avatar-block">
        <img class="user-avatar" [src]="picture" alt="demo-avatar">
        
        <div class="user-name-wrap">
          <span class="user-name">{{ firstName }} {{ lastName }}</span>
        </div>

      </div>
      <div class="infos-block">
        <p><span class="label">{{ 'pages.user-cards.create.steps.information.sex' | translate }}:</span> {{ 'pages.user-cards.create.steps.confirmation.' + sex | translate }}</p>
        <p><span class="label">{{ 'pages.user-cards.create.steps.information.birthdate' | translate }}:</span> {{ birthDate }}</p>
      </div>
    </div>
    <!-- Address selector list -->
    <div class="address-selector" *ngIf="userAddresses.length > 0">
      <span class="label">{{ 'pages.profile.mainAddress' | translate }}:</span>
      <div class="address-option"
        *ngFor="let pa of userAddresses; let i = index"
        [class.selected]="selectedAddressIndex === i"
        (click)="selectAddress(i)">
        <span class="address-radio">
          <span class="radio-dot" [class.active]="selectedAddressIndex === i"></span>
        </span>
        <span class="address-option-text">
          {{ pa.displayName }} &mdash;
          {{ pa.address.unit ? '#' + pa.address.unit + ' ' : '' }}{{ pa.address.number }} {{ pa.address.streetName || pa.address.street }}, {{ pa.address.city }}
        </span>
        <span class="address-chips">
          <span *ngIf="i === 0" class="address-chip address-chip--primary">
            {{ 'pages.profile.addresses.primaryResidence' | translate }}
          </span>
          <span *ngIf="pa.isVerified" class="address-chip address-chip--verified">
            {{ getVerifiedLabel(pa) | translate }}
          </span>
          <span *ngIf="!pa.isVerified" class="address-chip address-chip--unverified">
            {{ 'pages.profile.addresses.unverified' | translate }}
          </span>
        </span>
      </div>
      <button type="button" class="address-add-btn" (click)="onAddNewAddress()">
        + {{ 'pages.profile.addresses.addAddress' | translate }}
      </button>
    </div>
    <!-- Warning: no addresses on profile -->
    <div class="no-address-warning" *ngIf="userAddressesLoaded && userAddresses.length === 0">
      <mat-icon class="no-address-warning__icon">warning</mat-icon>
      <span class="no-address-warning__text">{{ 'pages.user-cards.create.steps.information.noAddressWarning' | translate }}</span>
    </div>
    <div class="subtype-wrapper" *ngIf="subTypes.length > 0 && userAddresses.length > 0">
      <app-user-card-select
        [options]="subTypes"
        controlName="subType"
        [form]="form"
        placeholder="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}"
        label="{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}"
        hint="{{ subTypeLocked ? ('pages.user-cards.create.steps.information.subTypes.forced' | translate) : '' }}"
        [disabled]="subTypeLocked">
      </app-user-card-select>
      <span class="subtype-lock-hint" *ngIf="subTypeLocked">
        <i class="icon-lock"></i>
      </span>
    </div>
  </div>
</form>